import { MappedClass, MappedProperty, MappedPropertyDate } from '@h5s/util-object';

import { DateTime } from 'luxon';

@MappedClass()
export class SendIstatRequest {
  @MappedProperty()
  availableBeds: number | null;

  @MappedProperty()
  availableRooms: number | null;

  @MappedProperty()
  istatCustomerIdsToInclude: string[];

  @MappedProperty()
  month: number | null;

  @MappedProperty()
  ownerIstatId: number;

  @MappedPropertyDate()
  referenceDate: DateTime | null;

  @MappedProperty()
  year: number | null;

  constructor(init?: Partial<SendIstatRequest>) {
    Object.assign(this, init);
  }
}
